import { QueryObserverBaseResult, useQuery } from "react-query";
import api, { createURLParams } from "../../client";
import { queryKeys } from "../../query";
import { RepresentativeListResponseData } from "../../types/representative";
import { QueryParams } from "../../types/base";

export const getData = async (params: QueryParams) => {
  const { data } = await api.get<RepresentativeListResponseData>(
    `/representatives${createURLParams(params)}`,
  );

  return data;
};

export const useRepresentatives = (
  params: QueryParams,
): QueryObserverBaseResult<RepresentativeListResponseData> => {
  const { data, ...props } = useQuery(
    queryKeys.representativeListPage(params),
    () => getData(params),
  );
  return { data, ...props };
};
